@if (isLoading()) {
  <div class="flex h-full w-full items-center justify-center bg-primary-container">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
} @else if (error()) {
  <div class="flex h-full w-full items-center justify-center bg-primary-container text-error">
    {{ error() }}
  </div>
} @else {
  <div class="h-full w-full flex flex-col">
    <!-- Header -->
    <div class="flex flex-wrap items-center justify-between gap-3 p-4 bg-primary-container border-b border-outline-variant">
      <h1 class="text-xl font-medium text-on-surface m-0">現場マップ</h1>
      <div class="flex flex-wrap items-center gap-3">
        <mat-button-toggle-group
          [value]="mapMode()"
          (change)="onMapModeChange($event.value)"
          aria-label="マップ表示モード">
          <mat-button-toggle value="temperature">{{ winterMode ? '気温' : 'WBGT' }}</mat-button-toggle>
          <mat-button-toggle value="wind">風向風速</mat-button-toggle>
        </mat-button-toggle-group>
        @if (canSaveMapSettings()) {
          <button matButton (click)="saveMapSettings()">
            現在の表示位置を保存
          </button>
        }
      </div>
    </div>

    <div class="flex flex-wrap items-center gap-x-4 gap-y-2 px-4 py-3 bg-primary-container border-b border-outline-variant text-on-surface">
      <span class="text-sm font-medium shrink-0">{{ legendTitle() }}</span>
      @for (item of legendItems(); track item.statusNo) {
        <span class="inline-flex items-center gap-1.5 text-xs sm:text-sm whitespace-nowrap">
          <span
            class="inline-block size-3 rounded-full border border-outline"
            [style.backgroundColor]="item.color"
            aria-hidden="true">
          </span>
          <span class="font-medium">{{ item.label }}</span>
          <span class="text-on-surface-variant">{{ item.range }}</span>
        </span>
      }
    </div>

    <!-- Map Container -->
    <div class="grow w-full relative">
      <google-map height="100%" width="100%" [options]="mapOptions" [mapId]="mapOptions.mapId!">
        @for (item of mapMarkers(); track item.site.id) {
          <map-advanced-marker
            #marker="mapAdvancedMarker"
            [position]="item.position"
            [content]="item.pin"
            [title]="item.site.name"
            [zIndex]="item.zIndex"
            (mapClick)="openInfoWindow(marker, item.site)">
          </map-advanced-marker>
        }
          <map-info-window>
            @if (selectedSite()) {
              <div class="p-2 flex flex-col gap-2 min-w-[200px]">
                <h3 class="text-base font-medium m-0">{{ selectedSite()!.name }}</h3>
                <div class="flex items-center gap-2">
                  <span class="text-sm text-on-surface-variant">
                    {{ mapMode() === 'wind' ? 'ステータス' : (winterMode ? '気温' : 'WBGT') }}:
                  </span>
                  <span [class]="getSelectedSiteStatusBadgeClass()">
                    {{ mapMode() === 'wind' ? (selectedSite()!.windSpeedStatusLabel || '未設定') : (selectedSite()!.wbgtStatusLabel || '未設定') }}
                  </span>
                </div>
                @if (mapMode() === 'wind') {
                  <div class="flex items-center gap-2 text-sm">
                    <span class="text-on-surface-variant">風速:</span>
                    <span>{{ selectedSite()!.windSpeedValue == null ? '未設定' : selectedSite()!.windSpeedValue + ' m/s' }}</span>
                  </div>
                  <div class="flex items-center gap-2 text-sm">
                    <span class="text-on-surface-variant">風向:</span>
                    <span>{{ selectedSite()!.windDirection || '未設定' }}</span>
                  </div>
                }
                <div class="flex justify-end pt-2">
                  <button matButton (click)="navigateToDetail(selectedSite()!.id)">
                    詳細を見る
                  </button>
                </div>
              </div>
            }
          </map-info-window>
      </google-map>
    </div>
  </div>
}
